import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { IMappedAddress } from '../../../models/common/addresses';

interface IAddressParagraphProps {
  address: IMappedAddress;
}

export const AddressParagraph = ({ address }: IAddressParagraphProps) => {
  const { addressLine1, addressLine2, state, zipCode, city } = address;

  return (
    <>
      <Typography data-qm-mask="" data-testid="addressLineOneContainer">
        {addressLine1}
      </Typography>
      {addressLine2 && (
        <Typography data-qm-mask="" data-testid="addressLineTwoContainer">
          {addressLine2}
        </Typography>
      )}
      <Typography data-qm-mask="">
        {city}, {state} {zipCode}
      </Typography>
    </>
  );
};

AddressParagraph.displayName = 'AddressParagraph';
